import Image from "next/image";
import Link from "next/link";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";

const socialLinks = [
  { icon: FaFacebookF, href: "https://www.facebook.com" },
  { icon: FaInstagram, href: "https://www.instagram.com" },
  { icon: FaLinkedinIn, href: "https://www.linkedin.com" },
];

const PARTNERS_LOGOS = [
  { id: 1, src: "/logos/CE MARK.png", name: "CE MARK" },
  { id: 2, src: "/logos/Logo IQS 14001-2015.png", name: "ISO 14001" },
  { id: 3, src: "/logos/Logo IQS 9001-2015.png", name: "ISO 9001" },
  { id: 4, src: "/logos/Logo IQS 45001-2018.png", name: "ISO 45001" },
  { id: 5, src: "/logos/A-0856 Logo.jpg" },
  { id: 6, src: "/logos/qualicoat.jpeg" },
  { id: 7, src: "/logos/qualicoat.png" },
  { id: 8, src: "/logos/Qualisteelcoat Logo RGB Pos.jpg" },
];

export default function Partners() {
  return (
    <div className="w-full mx-auto pb-8">
      <div className="flex flex-col md:flex-row justify-between items-center gap-8">
        <div className="flex flex-col gap-4 items-center md:items-start">
          <div className="flex gap-4">
            {socialLinks.map(({ icon: Icon, href }, idx) => (
              <Link
                href={href}
                key={idx}
                aria-label="social link"
                className="group relative w-12 h-12 rounded-2xl border border-white/10 bg-white/5 flex items-center justify-center overflow-hidden transition-all duration-300 hover:border-brand-red hover:shadow-[0_0_20px_rgba(173,31,35,0.2)]"
              >
                <span className="absolute inset-0 bg-brand-red translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" />
                <Icon
                  size={20}
                  className="relative z-10 text-gray-400 transition-colors duration-300 group-hover:text-white"
                />
              </Link>
            ))}
          </div>
        </div>

        {/* Partners Logos Section */}
        <div className="flex flex-col gap-4 items-center md:items-end">
          <div className="flex flex-wrap justify-center gap-6 items-center bg-white/5 p-4 rounded-2xl border border-white/5 lg:w-lg">
            {PARTNERS_LOGOS.map((partner) => (
              <div key={partner.id} className="relative group">
                <div className="relative">
                  <Image
                    width={70}
                    height={70}
                    src={partner.src}
                    alt={partner?.name || "Partner Logo"}
                    className="h-12 w-auto object-contain   hover:opacity-100 transition-all duration-300 cursor-pointer"
                  />
                  {/* Tooltip on hover */}
                  {partner?.name && (
                    <span className="absolute -top-10 left-1/2 -translate-x-1/2 bg-brand-red text-white text-[10px] py-1 px-2 rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap">
                      {partner?.name || "Partner Logo"}
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
